export default "__VITE_ASSET__SRq0BJsX__"